module.exports = __webpack_public_path__ + "img/h-twitter.4966e88c.svg";